import { AddOverlay } from 'components/ContainerTable';
import React from 'react';

export const AddContainersOverlay: React.FC = () => {
  return <AddOverlay variant="container" openAddModal={() => {}} />;
};
AddContainersOverlay.displayName = 'TrackAndTrace.ContainerTable.AddContainersOverlay';
